// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.h8ZhBt5OcnBAKvND0yEH {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1000;
}

.BnK6B_f1gXrpZ9op1Qsa {
  background-color: #242c56;
  border: none;
  border-radius: 30%;
  padding: 10px;
  font-size: 24px;
  color: #fff;
  cursor: pointer;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
  transition: background-color 0.3s, transform 0.3s;
  display: flex;
  justify-content: center;
  align-items: center;
}
.BnK6B_f1gXrpZ9op1Qsa:hover {
  background-color: #fff;
  color: #242c56;
  transform: scale(1.1);
}`, "",{"version":3,"sources":["webpack://./src/components/BackToTop/BackToTop.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;AACF;;AAEA;EACE,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;EACA,wCAAA;EACA,iDAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACF;AACE;EACE,sBAAA;EACA,cAAA;EACA,qBAAA;AACJ","sourcesContent":[".BackToTop {\n  position: fixed;\n  bottom: 20px;\n  right: 20px;\n  z-index: 1000;\n}\n\n.TopButton {\n  background-color: #242c56;\n  border: none;\n  border-radius: 30%;\n  padding: 10px;\n  font-size: 24px;\n  color: #fff;\n  cursor: pointer;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);\n  transition: background-color 0.3s, transform 0.3s;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  &:hover {\n    background-color: #fff;\n    color: #242c56;\n    transform: scale(1.1);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"BackToTop": `h8ZhBt5OcnBAKvND0yEH`,
	"TopButton": `BnK6B_f1gXrpZ9op1Qsa`
};
export default ___CSS_LOADER_EXPORT___;
